import { FormHandles } from '@unform/core';
import { matchCartao, matchCartaoDataValida, matchCpf } from 'libs/yup/matches';
import { YupUtilsCatch, YupUtilsTry } from 'libs/yup/ShapeValidation';
import React, { createRef, FC, useContext, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { AuthContext } from 'routes/auth.context';
import * as yup from 'yup';
import ComponentInserirSaldo from './Component';
import { useInserirSaldo } from './hooks/useInserirSaldo';
import { useTypePayment } from './hooks/useTypePayment';
import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
interface IParams {
    unidadeId: string;
}

const PageInserirSaldo: FC = () => {
    const { unidadeId } = useParams<IParams>();
    const { unidadeSelecionada, unidades, alertConfirm, user } =
        useContext(AuthContext);
    const refUnidadeId = useRef(null);
    const refUsuarioId = useRef(null);
    const [loading, setLoading] = React.useState(false);

    useEffect(() => {
        if (unidadeId) {
            refUnidadeId.current = unidadeId;
        } else if (unidadeSelecionada?.id) {
            refUnidadeId.current = unidadeSelecionada?.id;
        } else if (unidades.length === 1) {
            refUnidadeId.current = unidades[0].id;
        }
    }, [unidadeId, unidadeSelecionada, unidades]);

    useEffect(() => {
        if (user) {
            refUsuarioId.current = user.id;
        }
    }, [user]);

    const inputs = useTypePayment();
    const rForm = createRef<FormHandles>();

    const createUser = (data) => {
        return axios.post(`${process.env.REACT_APP_HOST_APIS}/api/asaas/checkout`, data)
    }

    const mutation = useMutation({
        mutationFn: createUser,
    })

    const handleSubmit = async (data) => {
        setLoading(true);
        try {
            if (!refUnidadeId.current) {
                throw new Error('Não foi possível identificar a unidade, selecione uma unidade');
            }
            data.unidadeId = refUnidadeId.current;
            data.usuarioId = refUsuarioId.current;
            mutation.mutate(data, {
                onSuccess: (response) => {
                    setLoading(false);
                    window.open(response.data.checkout.link, '_blank');
                },
                onError: (error: any) => {
                    setLoading(false);
                    alertConfirm({
                        tipo: 'erro',
                        titulo: 'Erro',
                        conteudo: error.response?.data?.message || error.message,
                    });
                }
            });
        } catch (err: any) {
            setLoading(false);
            if (err.name !== 'ValidationError') {
                alertConfirm({
                    tipo: 'erro',
                    titulo: 'Erro',
                    conteudo: err.message,
                });
            }
        }
    };
    const oProps = {
        inputs,
        loading,
        rForm,
        user,
        handleSubmit,
    };
    return <ComponentInserirSaldo {...oProps} />;
};
export default PageInserirSaldo;
